// extracted by mini-css-extract-plugin
module.exports = {"ManageContent":"ManageCopy_ManageContent__1lwBF"};